module.exports = __webpack_public_path__ + "img/1526010098.63eb823e.jpg";